import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  MenuItem,
  Card,
  CardContent,
   ListItemButton,
  Link,
  Stack
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  Search,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données hiérarchisées
const populationData = {
  title: "Effectif de la population résidente par province, commune selon le sexe et le rapport de masculinité",
  provinces: [
    {
      name: "BUHUMUZA",
      communes: [
        { name: "BUTAGANZWA", total: "109 813", masculin: "52 629", feminin: "57 184", proportionMasculin: "47,9", proportionFeminin: "52,1", masculinityRatio: "92,0" },
        { name: "BUTIHINDA", total: "434 166", masculin: "207 178", feminin: "226 988", proportionMasculin: "47,7", proportionFeminin: "52,3", masculinityRatio: "91,3" },
        { name: "CANKUZO", total: "161 287", masculin: "78 438", feminin: "82 849", proportionMasculin: "48,6", proportionFeminin: "51,4", masculinityRatio: "94,7" },
        { name: "GISAGARA", total: "291 398", masculin: "139 923", feminin: "151 475", proportionMasculin: "48,0", proportionFeminin: "52,0", masculinityRatio: "92,4" },
        { name: "GISURU", total: "337 649", masculin: "162 122", feminin: "175 527", proportionMasculin: "48,0", proportionFeminin: "52,0", masculinityRatio: "92,4" },
        { name: "MUYINGA", total: "495 927", masculin: "237 315", feminin: "258 612", proportionMasculin: "47,9", proportionFeminin: "52,1", masculinityRatio: "91,8" },
        { name: "RUYIGI", total: "222 021", masculin: "108 004", feminin: "114 017", proportionMasculin: "48,6", proportionFeminin: "51,4", masculinityRatio: "94,7" }
      ],
      total: "2 052 261",
      masculin: "985 609",
      feminin: "1 066 652",
      proportionMasculin: "48",
      proportionFeminin: "52",
      masculinityRatio: "92,4"
    },
    {
      name: "BUJUMBURA",
      communes: [
        { name: "BUBANZA", total: "242 978", masculin: "117 952", feminin: "125 026", proportionMasculin: "48,5", proportionFeminin: "51,5", masculinityRatio: "94,3" },
        { name: "BUKINANYANA", total: "269 547", masculin: "130 834", feminin: "138 713", proportionMasculin: "48,5", proportionFeminin: "51,5", masculinityRatio: "94,3" },
        { name: "CIBITOKE", total: "260 776", masculin: "127 680", feminin: "133 096", proportionMasculin: "49,0", proportionFeminin: "51,0", masculinityRatio: "95,9" },
        { name: "ISARE", total: "149 273", masculin: "70 357", feminin: "78 916", proportionMasculin: "47,1", proportionFeminin: "52,9", masculinityRatio: "89,2" },
        { name: "MPANDA", total: "362 261", masculin: "179 666", feminin: "182 595", proportionMasculin: "49,6", proportionFeminin: "50,4", masculinityRatio: "98,4" },
        { name: "MUGERE", total: "512 881", masculin: "250 294", feminin: "262 587", proportionMasculin: "48,8", proportionFeminin: "51,2", masculinityRatio: "95,3" },
        { name: "MUGINA", total: "225 284", masculin: "109 909", feminin: "115 375", proportionMasculin: "48,8", proportionFeminin: "51,2", masculinityRatio: "95,3" },
        { name: "MUHUTA", total: "117 061", masculin: "55 372", feminin: "61 689", proportionMasculin: "47,3", proportionFeminin: "52,7", masculinityRatio: "89,8" },
        { name: "MUKAZA", total: "168 829", masculin: "96 895", feminin: "71 934", proportionMasculin: "57,4", proportionFeminin: "42,6", masculinityRatio: "134,7" },
        { name: "NTAHANGWA", total: "927 907", masculin: "475 466", feminin: "452 441", proportionMasculin: "51,2", proportionFeminin: "48,8", masculinityRatio: "105,1" },
        { name: "RWIBAGA", total: "116 758", masculin: "54 537", feminin: "62 221", proportionMasculin: "46,7", proportionFeminin: "53,3", masculinityRatio: "87,7" }
      ],
      total: "3 353 555",
      masculin: "1 668 962",
      feminin: "1 684 593",
      proportionMasculin: "49,8",
      proportionFeminin: "50,2",
      masculinityRatio: "99,1"
    },
    {
      name: "BURUNGA",
      communes: [
        { name: "BURURI", total: "189 958", masculin: "90 393", feminin: "99 565", proportionMasculin: "47,6", proportionFeminin: "52,4", masculinityRatio: "90,8" },
        { name: "MAKAMBA", total: "370 637", masculin: "175 272", feminin: "195 365", proportionMasculin: "47,3", proportionFeminin: "52,7", masculinityRatio: "89,7" },
        { name: "MATANA", total: "195 269", masculin: "93 639", feminin: "101 630", proportionMasculin: "48,0", proportionFeminin: "52,0", masculinityRatio: "92,1" },
        { name: "MUSONGATI", total: "336 347", masculin: "161 159", feminin: "175 188", proportionMasculin: "47,9", proportionFeminin: "52,1", masculinityRatio: "92,0" },
        { name: "NYANZA", total: "369 669", masculin: "179 952", feminin: "189 717", proportionMasculin: "48,7", proportionFeminin: "51,3", masculinityRatio: "94,9" },
        { name: "RUMONGE", total: "429 237", masculin: "206 626", feminin: "222 611", proportionMasculin: "48,1", proportionFeminin: "51,9", masculinityRatio: "92,8" },
        { name: "RUTANA", total: "227 434", masculin: "109 813", feminin: "117 621", proportionMasculin: "48,3", proportionFeminin: "51,7", masculinityRatio: "93,4" }
      ],
      total: "2 118 551",
      masculin: "1 016 854",
      feminin: "1 101 697",
      proportionMasculin: "48,0",
      proportionFeminin: "52,0",
      masculinityRatio: "92,3"
    },
    {
      name: "BUTANYERERA",
      communes: [
        { name: "BUSONI", total: "357 991", masculin: "170 335", feminin: "187 656", proportionMasculin: "47,6", proportionFeminin: "52,4", masculinityRatio: "90,8" },
        { name: "KAYANZA", total: "332 433", masculin: "157 441", feminin: "174 992", proportionMasculin: "47,4", proportionFeminin: "52,6", masculinityRatio: "90,0" },
        { name: "KIREMBA", total: "292 027", masculin: "137 799", feminin: "154 228", proportionMasculin: "47,2", proportionFeminin: "52,8", masculinityRatio: "89,3" },
        { name: "KIRUNDO", total: "478 492", masculin: "228 361", feminin: "250 131", proportionMasculin: "47,7", proportionFeminin: "52,3", masculinityRatio: "91,3" },
        { name: "MATONGO", total: "265 900", masculin: "121 775", feminin: "144 125", proportionMasculin: "45,8", proportionFeminin: "54,2", masculinityRatio: "84,5" },
        { name: "MUHANGA", total: "222 791", masculin: "99 687", feminin: "123 104", proportionMasculin: "44,7", proportionFeminin: "55,3", masculinityRatio: "81,0" },
        { name: "NGOZI", total: "316 808", masculin: "151 651", feminin: "165 157", proportionMasculin: "47,9", proportionFeminin: "52,1", masculinityRatio: "91,8" },
        { name: "TANGARA", total: "263 764", masculin: "121 687", feminin: "142 077", proportionMasculin: "46,1", proportionFeminin: "53,9", masculinityRatio: "85,6" }
      ],
      total: "2 530 206",
      masculin: "1 188 736",
      feminin: "1 341 470",
      proportionMasculin: "47",
      proportionFeminin: "53",
      masculinityRatio: "88,6"
    },
    {
      name: "GITEGA",
      communes: [
        { name: "BUGENDANA", total: "229 652", masculin: "102 918", feminin: "126 734", proportionMasculin: "44,8", proportionFeminin: "55,2", masculinityRatio: "81,2" },
        { name: "GISHUBI", total: "243 533", masculin: "101 610", feminin: "141 923", proportionMasculin: "41,7", proportionFeminin: "58,3", masculinityRatio: "71,6" },
        { name: "GITEGA", total: "528 528", masculin: "244 171", feminin: "284 357", proportionMasculin: "46,2", proportionFeminin: "53,8", masculinityRatio: "85,9" },
        { name: "KARUSI", total: "377 638", masculin: "177 778", feminin: "199 860", proportionMasculin: "47,1", proportionFeminin: "52,9", masculinityRatio: "89,0" },
        { name: "KIGANDA", total: "149 522", masculin: "68 276", feminin: "81 246", proportionMasculin: "45,7", proportionFeminin: "54,3", masculinityRatio: "84,0" },
        { name: "MURAMVYA", total: "171 010", masculin: "79 435", feminin: "91 575", proportionMasculin: "46,5", proportionFeminin: "53,5", masculinityRatio: "86,7" },
        { name: "MWARO", total: "149 190", masculin: "70 429", feminin: "78 761", proportionMasculin: "47,2", proportionFeminin: "52,8", masculinityRatio: "89,4" },
        { name: "NYABIHANGA", total: "175 208", masculin: "78 711", feminin: "96 497", proportionMasculin: "44,9", proportionFeminin: "55,1", masculinityRatio: "81,6" },
        { name: "SHOMBO", total: "253 934", masculin: "117 580", feminin: "136 354", proportionMasculin: "46,3", proportionFeminin: "53,7", masculinityRatio: "86,2" }
      ],
      total: "2 278 215",
      masculin: "1 040 908",
      feminin: "1 237 307",
      proportionMasculin: "45,7",
      proportionFeminin: "54,3",
      masculinityRatio: "84,1"
    }
  ],
  total: {
    total: "12 332 788",
    masculin: "5 901 069",
    feminin: "6 431 719",
    proportionMasculin: "47,8",
    proportionFeminin: "52,2",
    masculinityRatio: "91,7"
  }
};

const PopulationDataPageM = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };
  // Calcul des indicateurs clés
  const keyStats = {
    totalPopulation: populationData.total.total,

    womenPercentage: populationData.total.proportionFeminin,

    mostPopulousProvince: populationData.provinces.reduce((max, province) => 
      parseFloat(province.total.replace(/\s/g, '')) > parseFloat(max.total.replace(/\s/g, '')) ? province : max
    ),

    leastPopulousProvince: populationData.provinces.reduce((min, province) => 
      parseFloat(province.total.replace(/\s/g, '')) < parseFloat(min.total.replace(/\s/g, '')) ? province : min
    ),

    highestWomenPercentage: populationData.provinces.reduce((max, province) => {
      const womenPct = parseFloat(province.proportionFeminin.replace(',', '.'));
      return womenPct > max.womenPct ? { province, womenPct } : max;
    }, { province: null, womenPct: 0 }),

    lowestWomenPercentage: populationData.provinces.reduce((min, province) => {
      const womenPct = parseFloat(province.proportionFeminin.replace(',', '.'));
      return womenPct < min.womenPct ? { province, womenPct } : min;
    }, { province: null, womenPct: 100 }),

    highestMasculinityRatio: populationData.provinces.reduce((max, province) => {
      const ratio = parseFloat(province.masculinityRatio.replace(',', '.'));
      return ratio > max.ratio ? { province, ratio } : max;
    }, { province: null, ratio: 0 }),

    lowestMasculinityRatio: populationData.provinces.reduce((min, province) => {
      const ratio = parseFloat(province.masculinityRatio.replace(',', '.'));
      return ratio < min.ratio ? { province, ratio } : min;
    }, { province: null, ratio: 200 })
  };

  const filteredProvinces = populationData.provinces.map(province => {
    if (!searchTerm) return province;
    
    const filteredCommunes = province.communes.filter(commune =>
      commune.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    return {
      ...province,
      communes: filteredCommunes,
      show: filteredCommunes.length > 0 || 
            province.name.toLowerCase().includes(searchTerm.toLowerCase())
    };
  }).filter(province => province.show || !searchTerm);


  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {populationData.title}
                    </Typography>
                  </Box>
                     <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                        <Grid item xs={12} sm={6} md={6} ></Grid>
                          <Grid item xs={12} sm={6} md={6}>
                      <TextField
                      size="small"
                      placeholder="Rechercher province/commune..."
                      variant="outlined"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: { xs: '100%', sm: '480px' } }}
                    />
                    </Grid>
                    </Grid>
              
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés par Province
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Totale
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {populationData.total.total}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Proportion Femmes
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {populationData.total.proportionFeminin}%
                              </Typography>
                              <Typography variant="caption">
                                Moyenne nationale
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Province la plus peuplée
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulousProvince.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulousProvince.total}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  habitants
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus fort rapport M/F
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.highestMasculinityRatio.province.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.highestMasculinityRatio.ratio.toFixed(1)}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province/Commune</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">% Masculin</TableCell>
                          <TableCell align="right">% Féminin</TableCell>
                          <TableCell align="right">Rapport M/F</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.total}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.masculin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.feminin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.proportionMasculin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.proportionFeminin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.masculinityRatio}</TableCell>
                        </ProvinceRow>

                        {/* Données par province et commune */}
                        {filteredProvinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.name)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />}
                                  {province.name}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{province.total}</TableCell>
                              <TableCell align="right">{province.masculin}</TableCell>
                              <TableCell align="right">{province.feminin}</TableCell>
                              <TableCell align="right">{province.proportionMasculin}</TableCell>
                              <TableCell align="right">{province.proportionFeminin}</TableCell>
                              <TableCell align="right">{province.masculinityRatio}</TableCell>
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={7}>
                                <Collapse in={expandedProvinces[province.name] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune, idx) => (
                                        <CommuneRow key={idx} hover>
                                          <TableCell sx={{ pl: 6 }}>{commune.name}</TableCell>
                                          <TableCell align="right">{commune.total}</TableCell>
                                          <TableCell align="right">{commune.masculin}</TableCell>
                                          <TableCell align="right">{commune.feminin}</TableCell>
                                          <TableCell align="right">{commune.proportionMasculin}</TableCell>
                                          <TableCell align="right">{commune.proportionFeminin}</TableCell>
                                          <TableCell align="right">{commune.masculinityRatio}</TableCell>
                                        </CommuneRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos des données démographiques
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Ces données représentent la population résidente du Burundi selon le Recensement Général de la Population, de l'Habitat, de l'Agriculture et Elevage (RGPHAE). 
                      La population résidente comprend toutes les personnes qui avaient leur résidence habituelle sur le territoire national au moment du recensement.
                    </Typography>
                    <Typography variant="body2" paragraph>
                      Le rapport de masculinité est calculé comme le nombre d'hommes pour 100 femmes. Un rapport:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="• Supérieur à 100 indique plus d'hommes que de femmes" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Inférieur à 100 indique plus de femmes que d'hommes" 
                        />
                      </ListItem>
                    </List>
                    <Typography variant="body2" mt={2}>
                      La moyenne nationale est de {populationData.total.masculinityRatio}, ce qui signifie qu'il y a environ {populationData.total.masculinityRatio.replace(',', '.')} hommes pour 100 femmes au Burundi.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, de l'Agriculture et Elevage (RGPHAE) 
                    réalisé en 2024. Les chiffres incluent toute la population résidente du Burundi. Les pourcentages sont calculés par rapport 
                    au total de chaque ligne (province ou commune). Le rapport de masculinité est calculé comme (Nombre d'hommes / Nombre de femmes) * 100.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageM;